module.exports = __webpack_public_path__ + "static/media/Dhelmise_gaussian2.56f43cac.png";